<template>
  <SimpleModuleDashboard
    :module-id="Modules.PROYECTOS"
    :profile-id="Profiles.PERSONAL"
    :actions="dashboardActions"
    include-php-custom
    :widget-groups="widgetGroups"
    :widget-tabs="widgetTabs"
    tabs-storage-key="tabs_view_dashboard_projects"
    :tabs-legacy-map="tabsLegacyMap"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

const WIDGET_GROUPS = {
  main: [
    'pie_activity_project',
    'pie_detail_project',
    'pie_detail_activity',
    'list_days_incomplete_hours',
  ],
  withExpiration: [
    'pie_projects_status',
    'list_projects_vencimientos_treinta_dias',
    'list_hours_estimated_vs_hurs_real',
  ],
  withoutExpiration: [
    'pie_projects_status_without_expiration',
    'list_hours_real_project_without_expiration',
  ],
}

const WIDGET_TABS = [
  { key: 'main', title: 'General' },
  { key: 'withExpiration', title: 'Proyectos con vencimiento' },
  { key: 'withoutExpiration', title: 'Proyectos sin vencimiento' },
]

const TABS_LEGACY_MAP = {
  with_expiration: 1,
  without_expiration: 2,
}

export default {
  components: {
    SimpleModuleDashboard,
  },
  data() {
    return {
      Modules,
      Profiles,
      widgetGroups: WIDGET_GROUPS,
      widgetTabs: WIDGET_TABS,
      tabsLegacyMap: TABS_LEGACY_MAP,
    }
  },
  computed: {
    employee() {
      return Helper.getEmployee()
    },
    employeeCanManageProjects() {
      return !!(this.employee && this.employee.permission_admin_projects)
    },
    dashboardActions() {
      return [
        {
          id: 'crudProject',
          reference: 'crudProject',
          route: 'ProjectStaffCrudProject',
          tone: 'primary',
        },
        {
          id: 'crudActivity',
          reference: 'crudActivity',
          route: 'ProjectStaffCrudActivity',
          tone: 'secondary',
          group: 'Configuraciones',
          visible: !this.employee || this.employeeCanManageProjects,
        },
        {
          id: 'crudHours',
          reference: 'crudHours',
          route: 'ProjectStaffCrudHours',
          tone: 'success',
          visible: !!this.employee || this.employeeCanManageProjects,
        },
      ]
    },
  },
}
</script>
